import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import { LogoIcon, LogoMaagtechnicIcon } from '../Icons';
var StyledLogo = /*#__PURE__*/styled.div.withConfig({
  displayName: "Logo__StyledLogo",
  componentId: "b4vvhm-0"
})(["cursor:", ";"], function (props) {
  return props.onClick ? 'pointer' : null;
});
var StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "Logo__StyledIcon",
  componentId: "b4vvhm-1"
})(["width:", ";height:", ";fill:", ";"], function (_ref) {
  var logowidth = _ref.logowidth,
    theme = _ref.theme;
  return logowidth === 'auto' ? '100%' : theme.sizes[logowidth];
}, function (_ref2) {
  var logoheight = _ref2.logoheight,
    theme = _ref2.theme;
  return logoheight === 'auto' ? '100%' : theme.sizes[logoheight];
}, function (_ref3) {
  var logoinverted = _ref3.logoinverted,
    theme = _ref3.theme;
  return logoinverted === 'true' ? theme.colors.logo.inverted : theme.colors.logo.primary;
});
var Logo = function Logo(_ref4) {
  var onClick = _ref4.onClick,
    maagtechnic = _ref4.maagtechnic,
    inverted = _ref4.inverted,
    width = _ref4.width,
    height = _ref4.height;
  return /*#__PURE__*/React.createElement(StyledLogo, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    logoinverted: inverted ? 'true' : 'false',
    as: maagtechnic ? LogoMaagtechnicIcon : LogoIcon,
    logowidth: width,
    logoheight: height
  }));
};
export default Logo;